import React from "react";
import { cn } from "@/lib/utils";
import { label } from "./odrApi";

const CLS = { DRAFT: "bg-info-bg text-info", FILED: "bg-warning-bg text-warning", SCREENING: "bg-warning-bg text-warning", NOTICE: "bg-copper-light text-copper", RESPONSE_PENDING: "bg-warning-bg text-warning", ACTIVE: "bg-success-bg text-success", RESOLVED: "bg-success-bg text-success" };
export const OdrStatus = ({ s }) => <span className={cn("rounded-full px-2 py-0.5 text-[11px] font-medium", CLS[s] || "bg-secondary text-ink-2")} data-testid="odr-status">{label(s)}</span>;
